// extracted by mini-css-extract-plugin
export default {"root":"ExclusionGroupControls_root__t9aTD"};